/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SessionPermissionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SessionPermissionsQuery = { me: { permissions: Array<{ isGranted: boolean, permission: { code: Types.UserPermissionCode } }> } };


export const SessionPermissionsDocument = gql`
    query SessionPermissions {
  me {
    permissions {
      isGranted: isGranted
      permission {
        code
      }
    }
  }
}
    `;

/**
 * __useSessionPermissionsQuery__
 *
 * To run a query within a React component, call `useSessionPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<SessionPermissionsQuery, SessionPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionPermissionsQuery, SessionPermissionsQueryVariables>(SessionPermissionsDocument, options);
      }
export function useSessionPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionPermissionsQuery, SessionPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionPermissionsQuery, SessionPermissionsQueryVariables>(SessionPermissionsDocument, options);
        }
export type SessionPermissionsQueryHookResult = ReturnType<typeof useSessionPermissionsQuery>;
export type SessionPermissionsLazyQueryHookResult = ReturnType<typeof useSessionPermissionsLazyQuery>;
export type SessionPermissionsQueryResult = Apollo.QueryResult<SessionPermissionsQuery, SessionPermissionsQueryVariables>;